import { render, staticRenderFns } from "./printLabel.vue?vue&type=template&id=53a99b67&scoped=true"
import script from "./printLabel.vue?vue&type=script&lang=js"
export * from "./printLabel.vue?vue&type=script&lang=js"
import style0 from "./printLabel.vue?vue&type=style&index=0&id=53a99b67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a99b67",
  null
  
)

export default component.exports